import { SxProps, Theme } from '@mui/material'

/** Shared panel padding/indent for all chart settings tabs */
export const chartSettingsTabPanelSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    pl: '9px',
    '& .MuiFormGroup-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
    },
}

export const chartSettingsSectionTitleSx = {
    fontSize: '11px',
    marginBottom: 1.5,
    color: (theme: Theme) => theme.palette.text.secondary,
}

export const chartSettingsSectionDividerSx = {
    marginTop: 2.5,
    marginBottom: 1.5,
}

export const chartSettingsFormGroupSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
}

export const chartSettingsRowSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    minHeight: 36,
    gap: 1,
}

/** Two-column row: fixed 100px label + controls (colors, inputs, etc.) */
export const chartSettingsGridRowSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: '100px 1fr',
    alignItems: 'center',
    minHeight: 36,
    columnGap: 1,
}

export const chartSettingsLabelSx: SxProps<Theme> = {
    width: 100,
    fontSize: '14px',
    flexShrink: 0,
}

export const chartSettingsCheckboxLabelSx: SxProps<Theme> = {
    width: 100,
    flexShrink: 0,
    ml: 0,
    mr: 0,
    '& .MuiFormControlLabel-label': { fontSize: '14px' },
}

export const chartSettingsFormControlLabelSx: SxProps<Theme> = {
    width: 100,
    flexShrink: 0,
    ml: 0,
    mr: 0,
    '& .MuiFormControlLabel-label': { fontSize: '14px' },
}

export const chartSettingsRowControlsSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
}
